<template>
<div class="chapter">
<div class="inner_page">
      ﻿



<title>Princeton University</title>
<link href="template.css" rel="stylesheet" type="text/css"/>
<p class="title-head">C<span class="small">ONTENTS</span></p>
<table>
<colgroup>
<col width="40px"/>
<col width="350px"/>
</colgroup>
<tbody>
<tr><td colspan="2"><span href="#/Title" title="Link target outside of Sample">Title Page</span></td></tr>
<tr><td colspan="2"><span href="#/Copyright" title="Link target outside of Sample">Copyright Page</span></td></tr>
<tr><td colspan="2"><a href="#/Acknowledgments#Ackno">Acknowledgments</a></td></tr>
<tr><td colspan="2"><a href="#/Introduction#Intro">Introduction</a></td></tr>
<tr><td><span href="#/Chapter01#C1" title="Link target outside of Sample">1.</span></td><td><span href="#/Chapter01#C1" title="Link target outside of Sample">Founding a College in New Jersey</span></td></tr>
<tr><td><span href="#/Chapter02#C2" title="Link target outside of Sample">2.</span></td><td><span href="#/Chapter02#C2" title="Link target outside of Sample">Revolutionary College</span></td></tr>
<tr><td><span href="#/Chapter03#C3" title="Link target outside of Sample">3.</span></td><td><span href="#/Chapter03#C3" title="Link target outside of Sample">God and Man at Presbyterian Princeton</span></td></tr>
<tr><td><span href="#/Chapter04#C4" title="Link target outside of Sample">4.</span></td><td><span href="#/Chapter04#C4" title="Link target outside of Sample">The Romance of College Life</span></td></tr>
<tr><td><span href="#/Chapter05#C5" title="Link target outside of Sample">5.</span></td><td><span href="#/Chapter05#C5" title="Link target outside of Sample">Becoming Princeton University</span></td></tr>
<tr><td><span href="#/Chapter06#C6" title="Link target outside of Sample">6.</span></td><td><span href="#/Chapter06#C6" title="Link target outside of Sample">Two Sides of Paradise</span></td></tr>
<tr><td><span href="#/Chapter07#C7" title="Link target outside of Sample">7.</span></td><td><span href="#/Chapter07#C7" title="Link target outside of Sample">The Long Fifties</span></td></tr>
<tr><td><span href="#/Chapter08#C8" title="Link target outside of Sample">8.</span></td><td><span href="#/Chapter08#C8" title="Link target outside of Sample">The Short Sixties</span></td></tr>
<tr><td><span href="#/Chapter09#C9" title="Link target outside of Sample">9.</span></td><td><span href="#/Chapter09#C9" title="Link target outside of Sample">Blending Tradition and Change</span></td></tr>
<tr><td><span href="#/Chapter10#C10" title="Link target outside of Sample">10.</span></td><td><span href="#/Chapter10#C10" title="Link target outside of Sample">Changing Stripes in a New Millennium</span></td></tr>
<tr><td colspan="2"><span href="#/Bibliography#Bibli" title="Link target outside of Sample">Bibliography</span></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?a5d3d774